module.exports = __webpack_public_path__ + "static/img/taiHeImg2.9efae56.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/taiHeImg2.png
// module id = BjKi
// module chunks = 2